import { isObj } from "./cond";

export const getUserRole = (user) => {
  if (!isObj(user)) {
    return null;
  }
  return user["https://decoder.withvalues.com/role"] || null;
};

export const createGroupingValue = (groupingString) => {
  return (groupingString || "").split("&").reduce((acc, item) => {
    const [key, value] = item.split("=");
    if (key && value) {
      // Decode URL-encoded value and split on commas
      const decodedValue = decodeURIComponent(value);
      const values = decodedValue
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v);

      acc[key] = values;
    }
    return acc;
  }, {});
};

// Filter Options Helper - for Grouping Segment
export const formatFilterOptions = (options) => {
  if (typeof options !== "string") return "";

  try {
    const obj = JSON.parse(options);
    const { demographics = {}, structures = {} } = obj;

    let html = "";

    // Helper function to format filter sections
    const formatSection = (sectionData, sectionTitle) => {
      if (Object.keys(sectionData).length === 0) return "";

      let sectionHtml = `<h2 class="font-bold">${sectionTitle}</h2><ul class="mb-4 text-sm">`;

      Object.entries(sectionData).forEach(([filterType, filterOptions]) => {
        const optionsList = Object.keys(filterOptions).join(", ");
        const capitalisedType =
          filterType.charAt(0).toUpperCase() + filterType.slice(1);
        sectionHtml += `<li>${capitalisedType} - ${optionsList}</li>`;
      });

      sectionHtml += "</ul>";
      return sectionHtml;
    };

    // Format both sections using the helper
    html += formatSection(demographics, "Demographics");
    html += formatSection(structures, "Structures");

    return html;
  } catch (error) {
    console.error("Error parsing filter options:", error);
    return "";
  }
};
